import type { Brain } from '@plone/types';
import cx from 'classnames';
import styles from './styles.module.css';
import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import BowlingCenterProducts from '@redturtle/qubicaamf-theme/components/Blocks/Listing/BowlingCenterProducts';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';
import config from '@plone/registry';
import { useLocation } from 'react-router-dom';

declare module '@plone/types' {
  interface Brain {
    bowling_center_region: string;
    lanesnr?: string;
    bowling_center_products: string[];
  }
}

interface BowlingCenterCardProps {
  title?: string;
  bowling_center_region?: string;
  lanesnr?: string;
  image_field?: string;
  image_scales?: object;
  item: Brain;
  producticons: any;
  block: string;
  query: any;
}
const PAQO = 'plone.app.querystring.operation';

const BowlingCenterCard = ({
  item,
  producticons,
  block,
  query,
}: BowlingCenterCardProps) => {
  let { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const Image = config.getComponent({ name: 'Image' }).component;
  const defaultImage = <img src={DefaultImageSVG} alt="" />;
  const lanesnr =
    item.lanesnr === '1' ? `${item.lanesnr} lane` : `${item.lanesnr} lanes`;

  let cardQs;
  if (query) {
    const blockQueryStringSearch = new URLSearchParams({
      ...query,
      query: JSON.stringify(query?.query)?.replace(
        /plone.app.querystring.operation/g,
        'paqo',
      ),
    }).toString();
    // abbiamo una ricerca se c'è la search e se la search non è solo la paginazione
    const have_search =
      search &&
      searchParams.size !== 1 &&
      [...searchParams.entries()].some(
        ([key, value]) => !key.startsWith('page_') && /^\d+$/.test(value),
      );
    if (!search.startsWith('?')) {
      search = '?' + search;
    }
    cardQs = have_search ? `${search}` : `${search}&${blockQueryStringSearch}`;
    // per passarlo correttamente devo sostituire i - con _ nel nome paginazione
    const qs_block_uid = block.replace(/-/g, '_');
    if (!cardQs.includes('page_')) {
      cardQs = `${cardQs}&page_${block}=1`;
    }
    // need this to not loose the parameter from the qs
    cardQs = cardQs.replace(qs_block_uid, block);
  } else {
    cardQs = '';
  }

  return (
    <div className={cx(styles.card, 'bowling-center-card')}>
      <div className={cx(styles.imagewrapper, 'image-wrapper')}>
        {(item.image_scales && (
          <Image
            item={item}
            className="card-image"
            alt=""
            loading="lazy"
            responsive
          />
        )) ||
          defaultImage}
        <div className={styles.overlay} />
        <BowlingCenterProducts
          bowlingCenterProducts={item.bowling_center_products}
          producticons={producticons}
        />
      </div>
      <div className={cx(styles.content, 'content')}>
        <div>
          <h3 className={styles.title}>
            <UniversalLink
              href={`${item['@id']}${cardQs}`}
              openLinkInNewTab={false}
            >
              {item.title}
            </UniversalLink>
          </h3>
          <p>
            {item.bowling_center_region} | {lanesnr}
          </p>
        </div>
        <p className={cx('bowling-card-description', styles.description)}>
          {item.description}
        </p>
        <div className={cx('bowling-card-cta', styles.cta)}>
          <CTA
            href={item['@id']}
            ctaButtonStyle="button"
            openLinkInNewTab={false}
            linkIcon=""
          >
            Learn more
          </CTA>
        </div>
      </div>
    </div>
  );
};

export default BowlingCenterCard;
